import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Router } from '@angular/router';
import { MessageService } from '../_services/message.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MustMatch } from '../_helpers/MustMatch';
import { ProductoService } from '../_services/producto.service';
import { Location } from '@angular/common';
import { ResponseUser } from '../_models/response-user.enum';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  step1: FormGroup;
  step2: FormGroup;
  @ViewChild('captchaRef') captcha: RecaptchaComponent;

  step1Ok = false;
  hiddenUserNotExist = true;

  constructor(private router: Router,
    private location: Location,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private fb: FormBuilder) {
  }

  ngOnInit(): void {
    const maxLength = Validators.minLength(6);

    this.step1 = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)]],
      captcha: ['', [Validators.required]]
    });

    this.step2 = this.fb.group({
      verificationcode: ['', [Validators.required]],
      password: ['', [Validators.required, maxLength]],
      confirmpassword: ['', [Validators.required, maxLength]]
    }, {
      validator: [
        MustMatch('password', 'confirmpassword')
      ]
    });
  }

  onSendPasswordRecover() {
    this.authenticationService.sendPasswordRecover(this.step1.value.email).subscribe(o => {
      this.step1Ok = true;
      this.hiddenUserNotExist = true;
    }, error => {
      //this.captcha.reset();
      switch (error.status) {
        case 409:
          if (error.error == ResponseUser.USERFEDERATEACCOUNT) {
            this.messageService.sendMessage("Información", "Tu registro fue con cuenta Google, intenta recuperar tu contraseña por ese medio.", null, "info");
            this.location.back();
          } else {
            this.messageService.sendMessage('<h2>Error</h2>', error.error, 0, 'danger');
          }
          break;
        default:
          this.messageService.sendErrorMessage();
          break;
      }
    });
  }

  volver() {
    this.location.back();
  }

  onResetPassword() {
    this.authenticationService.changePassword(this.step1.value.email, this.step2.value.verificationcode, this.step2.value.password).subscribe(o => {
      this.messageService.sendMessage('Modificación de Contraseña', 'Su contraseña ha sido modificada exitosamente.', 0, 'info');
      this.location.back();
    }, error => {
      switch (error.status) {
        case 401:
        case 409:
          this.messageService.sendMessage('<h2>Error</h2>', error.error, 0, 'danger');
          break;
        default:
          this.messageService.sendErrorMessage();
          break;
      }
    });
  }
}
